import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSendStyle0 = cosmosIconCss;

const CosmosIconSend$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSend extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '529d0dfec79ace404463dcee16d6f565c5ba376b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8c1208dc4d3b2f211e426c75a960418744d708a6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e20606d06f01259c274cc8db5d8aff5b7b475f7e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.723 11.257a.5.5 0 0 0 0-.894l-14-7.001A.5.5 0 0 0 4 3.809V9.61l8.753 1.095c.292.036.292.46 0 .496L4 12.295v5.516a.5.5 0 0 0 .724.447l14-7Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSendStyle0; }
}, [1, "cosmos-icon-send", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-send"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-send":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSend$1);
            }
            break;
    } });
}

const CosmosIconSend = CosmosIconSend$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSend, defineCustomElement };
